import React, { useState, useEffect, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  moorockCoords,
} from '../../constants';
import { Overlay } from './components/Overlay/Overlay';
import {
  getGridData,
  getObstaclesData,
} from '../../actions/aerospaceActions';
import { AeroMap } from './components/Map/AeroMap';
import { supportedLocations } from './components/Map/Location/locationData';
import { subscribeToLiveAircraft } from 'actions/liveAircraftActions';
import { getGeofences } from 'actions/geofenceActions';
import { LatLngTuple, Map } from 'leaflet';

const initialLocation = moorockCoords;

const Aerospace = ({
  requestGridData,
  requestObstaclesData,
  getGeofences,
}) => {
  const mapRef = useRef<Map>();

  useEffect(() => {
    requestGridData(initialLocation);
    requestObstaclesData(initialLocation);
    getGeofences();

    return () => {};
  }, [getGeofences, requestGridData, requestObstaclesData]);

  const [focus, setFocus] = useState('oranmore');
  const [zoomLevel, setZoomLevel] = useState('summary');

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(subscribeToLiveAircraft());
    return () => {};
  }, [dispatch]);
  const [zoom, setZoom] = useState(16);
  const moveMap = key => {
    try {
      const currentLoc = supportedLocations.find(loc => loc.key === key);
      if (currentLoc?.coords && mapRef?.current) {
        console.log(mapRef.current?.panTo(currentLoc?.coords as LatLngTuple));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleLocationChange = (event, newFocus) => {
    if (newFocus) {
      setFocus(newFocus);
      moveMap(newFocus);
    } else {
      moveMap(focus);
    }
  };
  const handleZoomChange = (event, newZoomLevel) => {
    if (newZoomLevel) {
      setZoomLevel(newZoomLevel);
    }
    const useZoomLevel = newZoomLevel || zoom;
    if (useZoomLevel === 'all') {
      setZoom(8);
      moveMap(focus);
    } else if (useZoomLevel === 'summary') {
      setZoom(10);
      moveMap(focus);
    } else if (useZoomLevel === 'detail') {
      setZoom(17);
      moveMap(focus);
    }
  };
  return (
    <div className="w-full h-full">
      <AeroMap
        mapRef={mapRef}
        zoom={zoom}
        setZoom={setZoom}
        setFocus={setFocus}
        overlay={
          <Overlay
            focus={focus}
            zoom={zoom}
            handleLocationChange={handleLocationChange}
            zoomLevel={zoomLevel}
            handleZoomChange={handleZoomChange}
          />
        }
      />
    </div>
  );
};

const mapStateToProps = null;

const mapDispatchToProps = dispatch => ({
  requestGridData: coords => dispatch(getGridData(coords)),
  requestObstaclesData: coords => dispatch(getObstaclesData(coords)),
  getGeofences: () => dispatch(getGeofences()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Aerospace);
